"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This component implements https://confluence.oci.oraclecorp.com/display/UX/Buttons
 */
var classNames = require("classnames");
var React = require("react");
var ScreenReaderOnly_1 = require("@oui/core/ScreenReaderOnly");
var InternalInput_1 = require("../components/form/inputs/InternalInput");
var util_1 = require("../utils/util");
var ButtonType;
(function (ButtonType) {
    /**
     * Submit button. Submits form-data.
     */
    ButtonType["Submit"] = "submit";
    /**
     * Reset button. Resets the form-data to its initial values.
     */
    ButtonType["Reset"] = "reset";
    /**
     * Regular button with no default behavior.
     */
    ButtonType["Button"] = "button";
})(ButtonType = exports.ButtonType || (exports.ButtonType = {}));
var ButtonStyle;
(function (ButtonStyle) {
    /**
     * Action button style.
     */
    ButtonStyle["Action"] = "oui-button-action";
    /**
     * Default button style.
     */
    ButtonStyle["Default"] = "oui-button-default";
    /**
     * Primary button style.
     * Use when making a distinction between primary & secondary actions.
     */
    ButtonStyle["Primary"] = "oui-button-primary";
    /**
     * Danger button style.
     */
    ButtonStyle["Danger"] = "oui-button-danger";
    /**
     * Link button style.
     */
    ButtonStyle["Link"] = "oui-button-link";
    /**
     * Muted link button style.
     */
    ButtonStyle["MutedLink"] = "oui-button-link oui-text-muted";
})(ButtonStyle = exports.ButtonStyle || (exports.ButtonStyle = {}));
var ButtonSize;
(function (ButtonSize) {
    /**
     * Default button size.
     */
    ButtonSize["Default"] = "";
    /**
     * Small button size.
     */
    ButtonSize["Small"] = "oui-button-small";
    /**
     * Larger button size.
     */
    ButtonSize["Large"] = "oui-button-large";
})(ButtonSize = exports.ButtonSize || (exports.ButtonSize = {}));
var ButtonIconPlacement;
(function (ButtonIconPlacement) {
    /**
     * Icon is placed before the text.
     */
    ButtonIconPlacement[ButtonIconPlacement["Before"] = 0] = "Before";
    /**
     * Icon is place after the text.
     */
    ButtonIconPlacement[ButtonIconPlacement["After"] = 1] = "After";
})(ButtonIconPlacement = exports.ButtonIconPlacement || (exports.ButtonIconPlacement = {}));
/**
 * OUI button component.
 * A button communicates what action will occur when the user clicks it.
 * It can include text, an icon, or both.
 *
 * @oui-component Button
 */
var Button = function (_a) {
    var _b;
    var label = _a.label, buttonSize = _a.buttonSize, buttonStyle = _a.buttonStyle, type = _a.type, buttonIcon = _a.buttonIcon, iconPlacement = _a.iconPlacement, children = _a.children, testId = _a.testId, forwardedRef = _a.forwardedRef, rest = __rest(_a, ["label", "buttonSize", "buttonStyle", "type", "buttonIcon", "iconPlacement", "children", "testId", "forwardedRef"]);
    var props = __assign({}, rest, { type: type || ButtonType.Button, className: classNames(
        // pure icon buttons do not get oui-button
        { "oui-button": !buttonIcon || !!children }, 
        // pure icon buttons need specific classes.
        { "oui-icon-link": buttonIcon && !children }, (_b = {}, _b["" + (buttonStyle || ButtonStyle.Default)] = !buttonIcon || !!children, _b), buttonSize || ButtonSize.Default), "data-test-id": testId }, util_1.ariaProps({ label: label }));
    var spanStyle = classNames({
        "oui-margin-small-left": buttonIcon && children && iconPlacement === ButtonIconPlacement.After
    }, {
        "oui-margin-small-right": buttonIcon && children && iconPlacement !== ButtonIconPlacement.After
    });
    var iconRatio = 1;
    if (buttonSize === ButtonSize.Small) {
        iconRatio = 0.6;
    }
    else if (buttonSize === ButtonSize.Large) {
        iconRatio = 1.5;
    }
    var iconAttr = "icon: " + buttonIcon + "; ratio: " + iconRatio;
    var iconSpan = buttonIcon && !!children ? (React.createElement("span", { className: spanStyle, "data-oui-icon": iconAttr })) : null;
    // pure icon buttons the icon goes on the button not a span.
    if (buttonIcon && !children) {
        if (!label) {
            console.warn([
                "Warning: oui-react - Button",
                "",
                "You must provide a label for pure icon buttons."
            ].join("\n"));
        }
        Object.assign(props, { "data-oui-icon": iconAttr });
    }
    return (React.createElement(InternalInput_1.default, __assign({}, props, { ref: forwardedRef }),
        (iconPlacement === ButtonIconPlacement.Before || !iconPlacement) &&
            iconSpan,
        children,
        label && React.createElement(ScreenReaderOnly_1.default, { from: "span" }, label),
        iconPlacement === ButtonIconPlacement.After && iconSpan));
};
var ForwardedButton = function (props, ref) { return (React.createElement(Button, __assign({}, props, { forwardedRef: ref }))); };
ForwardedButton.displayName = "forwarded(Button)";
exports.default = React.forwardRef(ForwardedButton);
//# sourceMappingURL=Button.js.map